// Generated by purs version 0.15.15
var AutoOrient = /* #__PURE__ */ (function () {
    function AutoOrient() {

    };
    AutoOrient.value = new AutoOrient();
    return AutoOrient;
})();
var AutoStartReverse = /* #__PURE__ */ (function () {
    function AutoStartReverse() {

    };
    AutoStartReverse.value = new AutoStartReverse();
    return AutoStartReverse;
})();
var showOrient = {
    show: function (v) {
        if (v instanceof AutoOrient) {
            return "AutoOrient";
        };
        if (v instanceof AutoStartReverse) {
            return "AutoStartReverse";
        };
        throw new Error("Failed pattern match at Halogen.Svg.Attributes.Orient (line 15, column 10 - line 17, column 43): " + [ v.constructor.name ]);
    }
};
var printOrient = function (v) {
    if (v instanceof AutoOrient) {
        return "auto";
    };
    if (v instanceof AutoStartReverse) {
        return "auto-start-reverse";
    };
    throw new Error("Failed pattern match at Halogen.Svg.Attributes.Orient (line 20, column 15 - line 22, column 43): " + [ v.constructor.name ]);
};
var eqOrient = {
    eq: function (x) {
        return function (y) {
            if (x instanceof AutoOrient && y instanceof AutoOrient) {
                return true;
            };
            if (x instanceof AutoStartReverse && y instanceof AutoStartReverse) {
                return true;
            };
            return false;
        };
    }
};
export {
    AutoOrient,
    AutoStartReverse,
    printOrient,
    eqOrient,
    showOrient
};
